import { render, staticRenderFns } from "./UICarousel.vue?vue&type=template&id=2d756eca&"
import script from "./UICarousel.vue?vue&type=script&lang=js&"
export * from "./UICarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports